import { colors } from '@dexma/ui-components';
import i18n from 'asset/translation';
import { WidgetType } from 'domain/entity/widget';
import { WidgetIssueSeverity } from 'domain/entity/widgetIssue';
import { WIDGET_ISSUE_I18N, WIDGET_ISSUE_ICON } from 'adapter/in/reports/utils/widgetIssuesConstants';

export interface WidgetIssueTokens {
    badgeBg: string;
    badgeText: string;
    cardBg: string;
    cardBorder: string;
    iconColor: string;
    icon: string;
}

const WIDGET_ISSUE_TOKENS: Record<WidgetIssueSeverity, WidgetIssueTokens> = {
    error: {
        badgeBg: colors.errorDefault,
        badgeText: colors.white,
        cardBg: colors.errorLighter,
        cardBorder: colors.errorLight,
        iconColor: colors.errorDark,
        icon: WIDGET_ISSUE_ICON.error,
    },
    warning: {
        badgeBg: colors.warningDefault,
        badgeText: colors.white,
        cardBg: colors.warningLight,
        cardBorder: colors.warningDefault,
        iconColor: colors.warningDarker,
        icon: WIDGET_ISSUE_ICON.warning,
    },
    info: {
        badgeBg: colors.infoDefault,
        badgeText: colors.white,
        cardBg: colors.infoLighter,
        cardBorder: colors.infoLight,
        iconColor: colors.infoDark,
        icon: WIDGET_ISSUE_ICON.info,
    },
};

export const widgetIssueTokens = (severity: WidgetIssueSeverity): WidgetIssueTokens => WIDGET_ISSUE_TOKENS[severity];

export const severityLabel = (severity: WidgetIssueSeverity): string => i18n.t(WIDGET_ISSUE_I18N.severity(severity));

export const widgetTypeLabel = (type?: WidgetType): string | undefined => (type ? i18n.t(WIDGET_ISSUE_I18N.widgetType(type)) : undefined);
